import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment/moment';
import { BehaviorSubject, Subject } from 'rxjs';
import { BackpackIconsModule } from '../../backpack-icons/backpack-icons.module';
import { DialogService } from '../../backpack/dialog-modal/dialog.service';
import { PressableTileComponent } from '../../backpack/pressable-tile/pressable-tile.component';
import { ResolveAssetPipe } from '../../backpack/resolve-asset.pipe';
import { SchoolActivityInstanceOverview } from '../../services/flex-daily-overview.service';
import { AddActivityStudentsWithOverrideComponent } from '../activity-student/add-activity-students-with-override.component';

@Component({
	standalone: true,
	selector: 'sp-activity-tile',
	templateUrl: './activity-tile.component.html',
	styleUrls: ['./activity-tile.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, AddActivityStudentsWithOverrideComponent, PressableTileComponent, BackpackIconsModule, ResolveAssetPipe],
})
export class ActivityTileComponent implements OnInit, OnDestroy {
	@Input() activityInstance: SchoolActivityInstanceOverview | null = null;
	@Input() roomColor = '';
	@Input() roomName = '';
	@Input() roomIcon = '';

	ended = false;
	attendeeCount$ = new BehaviorSubject<number>(0);

	private destroy$: Subject<void> = new Subject<void>();

	constructor(public dialogService: DialogService, public cdr: ChangeDetectorRef) {}

	ngOnInit(): void {
		if (this.activityInstance) {
			this.attendeeCount$.next(this.activityInstance.attendee_count);
			const endTime = moment(this.activityInstance.end_time);
			this.ended = moment().isAfter(endTime);
		} else {
			this.ended = false;
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next(undefined);
		this.destroy$.complete();
	}
}
